<template>
    <div class="mobileIndex">
        <van-sticky>
            <van-nav-bar :title="title" :left-text="showBack?'返回':''" :left-arrow="showFooter" @click-left="goBack">
                <template #right>
                    <template v-if="showRightControl">
                        <span class="m-langTxt" @click="show = true">{{langName}}</span>
                        <van-icon name="stop-circle-o" size="18" @click="close"/>
                    </template>
                    <template v-else>
                        <span class="m-langTxt" :style="{color:(isBalePage&&isShowBaleControl || !isBalePage&&isShowLabelingControl)?'#409eff':'#ccc'}" @click="isBalePage?showBaleControlEvent():showLabelingControlEvent()">{{isBalePage ? '条码':'箱唛'}}</span>
                    </template>
                </template>
            </van-nav-bar>
        </van-sticky>
        
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>

        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />

        <footer v-show="showFooter" class="footer"><span class="pull-left">当前仓库：{{warehouseName}}</span><span class="pull-right">操作人：{{user.realName}}</span></footer>
    </div>
</template>

<script>
import { NavBar,Icon,ActionSheet,Sticky, Toast } from 'vant';
import { mapState,mapMutations } from 'vuex'
import { getUserByToken } from '@/api/api';
import '@vant/touch-emulator';

export default {
    data() {
        return {
            showFooter: true,
            showBack: true,
            show: false,
            actions: [{name:'中文'},{name:'English'}],
            title: '',
            langName: '',
            user: {},
            warehouseName: '',
            viewportHeight: 0,
            showRightControl: true,
            isShowBaleControl: false,
            isShowLabelingControl: false,
            isBalePage: true
        }
    },

    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [ActionSheet.name]: ActionSheet,
      [Sticky.name]: Sticky 
    },

    computed: {
        ...mapState({ showBaleControl: state => state.user.showBaleControl,showLabelingControl: state => state.user.showLabelingControl,language: state => state.user.language,warehouse: state => state.common.warehouse,changeShowFooter: state => state.common.showMobileFooter,mobileTitle: state => state.common.mobileTitle })
    },

    created() {
        this.init()
    },
    
    mounted(){
        if(!window.localStorage.user){
            this.getUserInfoByToken()
        }else{
            this.user = JSON.parse(window.localStorage.user)
        }
        try{
            this.warehouseName = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse).warehouseName : this.warehouse.warehouseName;
        }catch{}
        
        this.phoneType()
    },

    methods: {
        ...mapMutations({
            changeShowMobileFooter: 'changeShowMobileFooter',
            saveMobileTitle: 'saveMobileTitle',
            changeShowBaleControl: 'changeShowBaleControl',
            changeShowLabelingControl: 'changeShowLabelingControl',
        }),
        init(){
            const that = this
            this.isWareHouse()
            this.scrollIntoView()
            this.title = this.$route.meta.title
            this.langName = this.language === 'zh' ? '中文' : 'English'

            // 键盘弹起隐藏footer
            this.viewportHeight = window.innerHeight
            window.addEventListener('resize',function(){
                if(that.viewportHeight - this.innerHeight > 50){ // 键盘弹起
                    that.changeShowMobileFooter(false)
                }else{ // 键盘收起
                    that.changeShowMobileFooter(true)
                }
            },true)
        },

        scrollIntoView(){
            const that = this
            window.addEventListener('resize', () => {
                const activeElement = document.activeElement
                if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA') {
                    setTimeout(() => {
                        activeElement.scrollIntoView(false)
                        that.changeShowMobileFooter(false)
                    }, 100)
                }else{
                    that.changeShowMobileFooter(true)
                }
            })
        },

        getUserInfoByToken() {
            var _this = this;
            const token = window.localStorage.Token
            var loginParams = {token};
            getUserByToken(loginParams).then(data => {
                if (!data.success) {
                    _this.$message({
                        message: data.msg?data.msg:'未分配权限',
                        type: 'error'
                    });
                } else {
                    window.localStorage.user = JSON.stringify(data.response)
                    this.user = data.response
                }
            });
        },

        onSelect(item){
            this.show = false

            const { name } = item
            const lan = name === "中文" ? 'zh' : 'en'

            this.$store.dispatch('setLanguage',lan)
            location.reload()
        },

        goBack(){
            this.$router.go(-1)
        },

        isWareHouse(){
            this.showFooter = this.$route.fullPath !== '/mobile/warehouse'
            this.showBack = this.$route.fullPath !== '/mobile/warehouse'
        },

        close(){
            window.localStorage.removeItem('user');
            window.localStorage.removeItem('Token');
            window.localStorage.removeItem('TokenExpire');
            window.localStorage.removeItem('NavigationBar');
            window.localStorage.removeItem('refreshtime');
            window.localStorage.removeItem('router');
            sessionStorage.removeItem("Tags");
            this.$store.commit("saveTagsData", "");

            this.$router.replace({path:'/login',query: { redirect: this.$route.fullPath }})
        },

        phoneType () {
            let type = navigator.userAgent
            if (type.indexOf('Android') > -1 || type.indexOf('Linux') > -1) {
                this.$store.dispatch('setPhoneType', 'Android')
            } else if (type.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                this.$store.dispatch('setPhoneType', 'IOS')
            } else {
                this.$store.dispatch('setPhoneType', 'Other')
            }
        },

        showBaleControlEvent(){
            const s = this.isShowBaleControl = !this.isShowBaleControl
            this.changeShowBaleControl(s)
        },

        showLabelingControlEvent(){
            const s = this.isShowLabelingControl = !this.isShowLabelingControl
            this.changeShowLabelingControl(s)
        }
    },
    
    watch: {
        $route: async function(newValue, from) {
            this.$nextTick(() => {
                // this.title = newValue.meta.title
                if(!newValue.path.includes('/picking') && !newValue.path.includes('/bale')){
                    this.saveMobileTitle(newValue.meta.title)
                }else if(newValue.path.includes('/pickingIndex') || newValue.path.includes('/baleIndex') || newValue.path.includes('/baleSingleSku') || newValue.path.includes('/baleMoreSku')){
                    this.saveMobileTitle(newValue.meta.title)
                }

                // 条码、箱唛打印控制
                if(newValue.path.includes('/bale')){
                    if( newValue.path.includes('/bale') && !newValue.path.includes('/baleSingleSku') && !newValue.path.includes('/baleMoreSku') && !newValue.path.includes('/baleIndex')){
                        this.showRightControl = false

                        this.isShowBaleControl = this.$store.state.showBaleControl
                    }else{
                        this.showRightControl = true
                    }
                }else{
                    if(newValue.path.includes('/labeling') && !newValue.path.includes('/labelingDetail') && !newValue.path.includes('/labelingList')){
                        this.showRightControl = false
                        this.isBalePage = false

                        this.isShowLabelingControl = this.$store.state.showLabelingControl
                    }else{
                        this.showRightControl = true
                        this.isBalePage = true
                    }
                }
                
                this.isWareHouse()
                this.changeShowMobileFooter(true)
            })
        },
        warehouse(n,o){
            this.warehouseName = n.warehouseName
        },
        changeShowFooter(n){
            this.showFooter = n
        },
        mobileTitle(n,o){
            this.title = n
        },
    }
}
</script>

<style scoped>
    .mobileIndex{
        padding-bottom: 50px;
    }
    .m-langTxt{
        margin-right: 10px;
    }
    
    .footer {
        position: fixed;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 0 1rem;
        background: #ccc;
        height: 3rem;
        line-height: 3rem;
        font-size: 0.75rem;
        z-index: 9;
    }
    
    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }
    ::v-deep .van-nav-bar__content{
        background-color: #35495e;
        color: #ccc;
    }
    ::v-deep .van-nav-bar__title{
        color: #fff;
    }
    ::v-deep .van-nav-bar .van-icon,::v-deep .van-nav-bar__text{
        color: #ccc;
    }
</style>